import React from "react"
import { NextSeo } from "next-seo"

import Layout from "~/components/Pages/Basic"
import Markdown from "~/components/Markdown"
import CancellationRefundPolicy from "~/content/cancellationRefundPolicy.md"

const CancellationRefundPolicyPage = () => {
  return (
    <>
      <NextSeo
        title="Cancellation and Refund Policy | WinIt"
        description="Understand WinIt's cancellation and refund policy for our parking and traffic ticket dispute services."
        canonical="https://www.appwinit.com/cancellation-refund-policy"
        additionalMetaTags={[
          {
            property: "description",
            content:
              "Understand WinIt's cancellation and refund policy for our parking and traffic ticket dispute services.",
          },
        ]}
      />
      <Layout>
        <Markdown src={CancellationRefundPolicy} />
      </Layout>
    </>
  )
}

export default CancellationRefundPolicyPage
